/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./finalizeLivestream.defs.js";
export { main as default } from "./finalizeLivestream.defs.js";
